import React, { useState, useEffect } from "react"
import { Redirect } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { makeStyles } from "@material-ui/core/styles"
import Paper from "@material-ui/core/Paper"
import Grid from "@material-ui/core/Grid"
import { Typography } from "@material-ui/core"
import Button from "@material-ui/core/Button"
import Snackbar from "@material-ui/core/Snackbar"
import MuiAlert from "@material-ui/lab/Alert"
import Link from "@material-ui/core/Link"

import Header from "../components/Header"
import SideMenu from "../components/menu/SideMenu"
import { CaseList, CreateCase } from "../components/bifrost"
import Modal, { ModalPopup } from "../components/modal"
import UploadFiles from "../components/bifrost/UploadFiles"
import { getCaseListRequest } from "../actions/bifrostActions"
import Notification from "../components/Notification/Notification"
import WithDrawer from "../components/common/drawer/withDrawer"

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
	},
	paper: {
		padding: theme.spacing(2),
		color: theme.palette.text.secondary,
	},
	header: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		padding: theme.spacing(2, 0),
	},
	notification: {
		padding: theme.spacing(2, 0),
	},
	headerTitle: {
		fontSize: 24,
		fontWeight: 500,
		color: "#3A3A3A",
	},
	headerButton: {
		backgroundColor: "background: #171D90",
		color: "#ffffff",
		textTransform: "initial",
		fontSize: 14,
		padding: theme.spacing(2, 3),
	},
	list: {
		//backgroundColor: "#F9FAFE",
		padding: theme.spacing(6, 0),
	},
	actionBtn: {
		textTransform: "initial",
		fontSize: 17,
	},
	caseSaveMessage: {
		display: "flex",
		alignItems: "center",
	},
	checkedCircle: {
		fontSize: 24,
		color: "#00a72c",
		marginRight: "5px",
	},
}))

function Alert(props) {
	return <MuiAlert elevation={6} variant="filled" {...props} />
}
const action = (
	<Button href="#text-buttons" color="primary">
		Upload
	</Button>
)

const PageBifrost = () => {
	const classes = useStyles()
	const dispatch = useDispatch()

	//const isCaseCreated = useSelector(state=> state.bifrost.isSaved);
	const caseList = useSelector((state) => state.bifrost.list)
	const isCaseListLoading = useSelector((state) => state.bifrost.isListLoading)

	const isUserLogedInt = useSelector((state) => state.authtentication.loggedIn)
	const [openCreateCaseModal, setOpenCreateCaseModal] = useState(false)
	const [openUploadModal, setOpenUploadModal] = useState(false)

	const [snackbar, setSnackbar] = useState({
		open: false,
		vertical: "top",
		horizontal: "right",
		message: "Case created successfully",
	})

	const { vertical, horizontal, open } = snackbar

	useEffect(() => {
		dispatch(getCaseListRequest())
	}, [])

	const snackbarClose = () => {
		setSnackbar({ ...snackbar, open: false })
	}

	const closeCreateCaseModal = (status = false) => {
		if (status) {
			//is true -> screate case success
			dispatch(getCaseListRequest())
			setSnackbar({ ...snackbar, open: true })
		}
		setOpenCreateCaseModal(false)
	}

	const handleUploadDocumentModal = () => {
		setSnackbar({ ...snackbar, open: false })
		setOpenUploadModal(true)
	}

	return (
		<>
			{isUserLogedInt ? null : <Redirect to={{ pathname: "/", state: "" }} />}
			{/* <div className="d-flex">
				<div className="container-xxl" id="contenido_principal" data-testid="contenido_principal">
					<div id="hero" className="hero">
						<div className="content" data-testid="bifrost-page">
							<div className={classes.root}>
								</div>
						</div>
					</div>
				</div>
			</div> */}
			<Grid className={classes.root} container direction="row" data-testid="all_cases_page">
				<Grid container>
					<Grid item xs={12} className={classes.header}>
						<Typography variant="h2" className={classes.headerTitle}>
							All cases
						</Typography>
						<Button
							variant="contained"
							color="primary"
							className={classes}
							style={{
								textTransform: "initial",
								fontSize: "14px",
								padding: "8px 12px",
								backgroundColor: "#171D90",
							}}
							onClick={() => setOpenCreateCaseModal(true)}
						>
							Create case
						</Button>
					</Grid>
					<Grid item xs={12} className={classes.notification}>
						<Notification />
					</Grid>
					<Grid item xs={12} className={classes.list}>
						<CaseList list={caseList} isLoading={isCaseListLoading} />
					</Grid>
				</Grid>
			</Grid>
			<ModalPopup title={"Create case"} open={openCreateCaseModal} setOpen={setOpenCreateCaseModal} outSideClickClose>
				<CreateCase callback={closeCreateCaseModal} />
			</ModalPopup>

			{/* <ModalPopup
                title={"Upload documents"}
                open={openUploadModal}
                setOpen={setOpenUploadModal}
                outSideClickClose
            >
                <UploadFiles
                    callback={closeCreateCaseModal}
                />
            </ModalPopup> */}

			<Snackbar
				anchorOrigin={{ vertical, horizontal }}
				open={open}
				onClose={snackbarClose}
				//message="Case created successfully"
				key={vertical + horizontal}
				action={action}
				autoHideDuration={3000}
			>
				{/* <Alert onClose={snackbarClose} severity="">
                    <div className=''>
                        <p className={classes.caseSaveMessage}><i className={`bi bi-check-circle-fill ${classes.checkedCircle}`}></i> Case created successfully</p>
                        <Button size="medium" color="primary" className={classes.actionBtn} >
                            Upload
                        </Button>
                    </div>

                </Alert> */}
				<Alert onClose={snackbarClose} severity="success">
					{snackbar.message}
					{/* <Link  onClick={handleUploadDocumentModal} style={{marginLeft: "8px", cursor:"pointer"}} >
                        Upload
                    </Link> */}
				</Alert>
			</Snackbar>
		</>
	)
}

export default WithDrawer(PageBifrost)
